module.exports = __webpack_public_path__ + "static/media/backlight1.5fddb00a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight/backlight1.jpg
// module id = 309
// module chunks = 0